import doc                 from '@widesk-core/decorators/doc';
import model               from '@widesk-core/decorators/model';
import ShopServiceModel    from '@/models/ShopServiceModel';
import TimestampAble       from '@widesk-core/models/traits/TimestampAble';
import Blamable            from '@/models/traits/Blamable';
import Translatable        from '@widesk-core/models/traits/Translatable';
import { RenderNameProps } from '@widesk-ui/mixins/ApiModelRenderName';

// //////////////////////////////////////////////////////////
// COPIE du fichier TaxonomyModel pour en faire un resolvable
// /////////////////////////////////////////////////////////

@model.urnResource('taxonomy')
@doc.path('/taxonomies/{?id}')
export default class ParentTaxonomyModel extends Blamable(TimestampAble(Translatable(ShopServiceModel, {
	'label': true,
}))) {
	private declare _tsFilters: {
		'createdAt[after]': string | Date | Dayjs;
		'createdAt[before]': string | Date | Dayjs;
		'createdAt[strictly_after]': string | Date | Dayjs;
		'createdAt[strictly_before]': string | Date | Dayjs;
		'enabled': '0' | '1';
		'exists[parent]': '0' | '1';
		'parent': id;
		'slug': id;
		'taxonomyEntertainments.entertainment': id;
		'taxonomyEntertainments.entertainment.entertainmentUrn': Urn;
		'translations.label': string;
		'updatedAt[after]': string | Date | Dayjs;
		'updatedAt[before]': string | Date | Dayjs;
		'updatedAt[strictly_after]': string | Date | Dayjs;
		'updatedAt[strictly_before]': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'position': string;
		'translations.label': string;
		'updatedAt': string;
	};

	@doc.boolean declare enabled: boolean;
	@doc.number declare position: number;
	@doc.string declare slug: string;

	public renderName(props?: RenderNameProps<this> & TaxonomyNameProps) {
		return super.renderName(props);
	}
}